import React, { forwardRef } from 'react';

import { Color } from 'baukasten';

import { FontSizeKeys } from '../styles/themes';
import { ProgressBar } from '../ProgressBar';
import { Box } from '../Box';
import { Text } from '../Text';

type ProgressIndicator = {
  value?: number;
  label: string;
  fontSize?: FontSizeKeys;
  disabled?: boolean;
  barWidth?: string;
  fontColor?: Color;
};

// TODO: replace the ${Math.round(value * 100)} with locale-dependent value formatting
const ProgressIndicator = forwardRef(
  (
    {
      value = 0,
      label,
      fontSize = 12,
      disabled,
      barWidth,
      fontColor,
    }: ProgressIndicator,
    ref: React.Ref<HTMLDivElement>
  ) => (
    <Box ref={ref} display="inline-flex" alignItems="center">
      <ProgressBar
        value={disabled ? 0 : value}
        width={barWidth}
        label={label}
      />
      <Box flex="0 0 auto">
        <Text fontSize={fontSize} color={fontColor ?? 'grey-dark'} ml={2}>
          {disabled ? '-' : `${Math.round(value * 100)}%`}
        </Text>
      </Box>
    </Box>
  )
);

export { ProgressIndicator };
